module.exports = __webpack_public_path__ + "static/media/2.67dedd33.jpg";